import { useEffect, useRef } from "react";
/**
 * A ref that always holds the value of the last COMMITTED render.
 *
 * The one legitimate latest-ref effect, shared rather than re-spelled at each
 * site: something outside the render cycle — an AI SDK transport building a
 * request, a debounced flush — has to read a value React re-derives every
 * render, without that consumer being re-created or re-armed each time.
 *
 * The write is a commit-phase effect, never a render-phase assignment: a render
 * that React throws away must not be able to publish its value.
 *
 * Deliberately has no dependency array. A consumer that must REACT to the value
 * rather than merely read it needs state, not this.
 */ export function useLatestRef(value) {
    const ref = useRef(value);
    useEffect(function mirrorLatestValue() {
        ref.current = value;
    });
    return ref;
}

//# sourceMappingURL=useLatestRef.js.map